// extracted by mini-css-extract-plugin
export default {"thin":"header_thin__1WZMW","small":"header_small__kugsP"};